module.exports = __webpack_public_path__ + "img/ios-stroe.32b4c60d.png";